import { useState } from 'react';
import { useUserListQuery } from '@common/cache';
import { useDrawerStore } from 'store/drawer.store.ts';
import { IUserTableEntry } from '../hooks/useUserTable';
import { useUserTableStore } from '../Filters/filters.store';

export const useUser = () => {
  const { filters, appliedFiltersCount } = useUserTableStore();
  const [selectedUserId, setSelectedUserId] = useState<string>('');

  const setDrawerOpen = useDrawerStore(state => state.setDrawerOpen);
  const isDrawerOpen = useDrawerStore(state => state.isDrawerOpen);

  const {
    data = {
      count: 0,
      users: [],
    },
    isRefetching,
    isFetching,
  } = useUserListQuery(filters);

  const entries: IUserTableEntry[] = data.users;

  const handleCloseDrawer = () => {
    setDrawerOpen(false);
    setSelectedUserId('');
  };

  const handleOpenUserDetails = (id: string) => {
    setSelectedUserId(id);
    setDrawerOpen(true);
  };

  return {
    entries,
    totalCount: data.count,
    isInitialFilters: appliedFiltersCount === 0 && !filters.search,
    isLoading: isRefetching || isFetching,
    handleCloseDrawer,
    handleOpenUserDetails,
    isDrawerOpen,
    selectedUserId,
  };
};
